import { Alert, AlertActionLink, Content } from "@patternfly/react-core";
import { useQueryClient } from "@tanstack/react-query";
import { type FC, useMemo } from "react";
import type { MKTAlert, MKTContent } from "../../constants/constants";

export const MarketingAlertComponent: FC = () => {
	const queryClient = useQueryClient();
	const alertContent = queryClient.getQueryData<MKTContent>(["marketingBlockData"])?.alert || null;
	const alert = useMemo<MKTAlert>(() => {
		return alertContent?.translations?.find((item) => item?.langcode === "en")?.field_values as MKTAlert;
	}, [alertContent]);
	const message = alert?.message || "";
	const isHTML = /<\/?[a-z][\s\S]*>/i.test(message);
	return alertContent ? (
		<Alert
			{...(alert?.allow_expansion && { isExpandable: true })}
			title={alert?.title}
			component="h2"
			variant={alert?.type || "info"}
			{...(alert?.ctas &&
				alert?.ctas?.length > 0 && {
					actionLinks: (
						<>
							{alert?.ctas?.map((elm, index) => (
								<AlertActionLink component="a" href={elm?.cta_url} key={index}>
									{elm?.cta_text}
								</AlertActionLink>
							))}
						</>
					),
				})}
		>
			{isHTML ? (
				<Content style={{ fontSize: "14px" }}>
					{/* biome-ignore lint/security/noDangerouslySetInnerHtml: marketing content is server-controlled HTML */}
					<div dangerouslySetInnerHTML={{ __html: message }} />
				</Content>
			) : (
				<p>{message}</p>
			)}
		</Alert>
	) : null;
};
